import * as t from "io-ts";

export const BreakdancePluginV = t.type({
  script: t.string
});

export type BreakdancePlugin = t.TypeOf<typeof BreakdancePluginV>;

export const BreakdancePluginsV = t.array(BreakdancePluginV);

export type BreakdancePlugins = t.TypeOf<typeof BreakdancePluginsV>;
